import { createStyles } from "antd-style";

export const useFooterContactsStyles = createStyles(({ css }: any) => ({
  section: css`
    background: #eef2fc;
  `,
  body: css`
    padding-block: 40px;
  `,
}));
